import(/* webpackMode: "eager" */ "/home/xuba0728/affectio-site/src/app/global.sass");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/xuba0728/nodevenv/affectio-site/19/lib/node_modules/next/dist/client/script.js");
